import defineService from "./defineService";
import {expandOrderLines} from "./basket";
import {fromApiAddressFormat, toApiAddressFormat} from "./mungeAddress";
import { getItemsPaginated } from './common';
import { AssertionError } from "assert";

const postSalesTax = defineService(
  "post",
  "api/v1/vendor/salestax/"
);

const getShippingMethods = defineService(
  'get',
  'api/v1/cart/basket/shipping-methods/'
);

const postCheckout = defineService(
  'post',
  'api/v1/cart/custom/checkout/'
);

const getOrder = defineService(
  'get',
  'api/v1/cart/orders/:id/',
  {alternatives: {
    paidWithVoucher: '-voucher' // payment method = voucher
  }}
);

const getOrders = defineService(
  'get',
  'api/v1/cart/orders/',
  {alternatives: {
    emptyTeam: '-empty' // an "empty" team -- no designs, team members, etc.
  }}
);

const getOrderLines = defineService(
  'get',
  'api/v1/cart/orders/:id/lines'
);

export const postReOrder = defineService(
  'post',
  'api/v1/cart/orders/:id/re-order/'
);

export async function calculateSalesTax(nexus, lineItems) {
  let fakeOrderNumber = 123;
  let payload = {address: nexus, line_items: lineItems, doc_code: fakeOrderNumber, paid: false};
  // console.log('calculateSalesTax', payload);
  let result;
  try {
    result = await postSalesTax(payload);
    // console.log('->', result);
  } catch(e) {
    // console.error('!!', e);
    // We're getting odd results from avalara
    // If the state is not CA, just return 0
    if (nexus.state && nexus.state != 'CA') return 0;
    else throw e;
  }
  return parseFloat(result.TotalTax, 10);
}

/**
 * Return a list of shipping methods for the current basket.
 * NOTE: this api will need to change if multiple shipping options are introduced
 */
export async function shippingMethods() {
  let result = await getShippingMethods();
  return result.map(({code, name, price}) => (
    {code, name, price: parseFloat(price.excl_tax, 10)}
  ));
}

/**
 * Sample:
 *
 *
 *
 * {
   "shipping_charge" : {
      "excl_tax" : 8,
      "tax" : 0,
      "incl_tax" : 8
   },
   "billing_address" : {
      "notes" : "",
      "city" : "Pacifica",
      "first_name" : "B",
      "postcode" : "94044",
      "line1" : "101 Main",
      "state" : "CA",
      "line2" : "",
      "country" : "/services/cart/api/v1/cart/countries/US/",
      "last_name" : "B"
   },
   "shipping_method_code" : "standard",
   "shipping_address" : {
      "first_name" : "B",
      "city" : "Pacifica",
      "notes" : "",
      "state" : "CA",
      "line1" : "101 Main",
      "postcode" : "94044",
      "phone_number" : "6502489279",
      "line2" : "",
      "last_name" : "B",
      "country" : "/services/cart/api/v1/cart/countries/US/"
   },
   "total" : "92.83",
   "basket" : "http://www.brandly.biz/services/cart/api/v1/cart/baskets/4456/",
   "guest_email" : "tony@brandly.com"
}
 * @param {*} orderInfo
 */
export async function placeOrder(checkoutInfo, paymentInfo, line_items) {
  checkoutInfo = toApiAddressFormat(checkoutInfo)
  let {paymentMethod, stripeToken, title, is_private} = paymentInfo;
  console.assert(checkoutInfo.guest_email);
  let orderInfo = await postCheckout({...checkoutInfo, payment_method: paymentMethod, stripe_token: stripeToken, title, available_to_team: !is_private});
  await postSalesTax({address: checkoutInfo.billing_address, doc_code: orderInfo.number, paid: true, line_items});
  orderInfo = await expandOrderLines(orderInfo);
  return fromApiAddressFormat(orderInfo);
}

/**
 * Find the order for the given ID.
 * @param {*} orderID
 */
export async function getOrderInfo(orderID) {
  console.assert(orderID);
  let order = await getOrder(orderID);
  order = await expandOrderLines(order);
  return fromApiAddressFormat(order);
}

/**
 * Return list of recently placed orders.
 */
export async function orders() {
  let {results=[]} = await getOrders();
  results = fromApiAddressFormat(results);
  await Promise.all(results.map(expandOrderLines));
  return results;
}

/**
 * Return orders for provided `payload`.
 *
 * @param {Object} payload
 * @returns {Promise<{results, count}>}
 */
export async function ordersPaginated(payload) {
  let { results, count } = await getItemsPaginated(getOrders, payload);
  results = fromApiAddressFormat(results);
  await Promise.all(results.map(expandOrderLines));
  return { results, count };
}



// WEBPACK FOOTER //
// ./src/services/checkout.js